import { jsx as _jsx } from "react/jsx-runtime";
import { usePosition } from '../../hooks';
import { Circle as CircleMarker, Triangle as TriangleMarker, Diamond as DiamondMarker, Square as SquareMarker, } from '../Markers';
const shapes = {
    triangle: Triangle,
    circle: Circle,
    diamond: Diamond,
    square: Square,
};
function Triangle(props) {
    return _jsx(TriangleMarker, { size: props.size, style: props.style }, void 0);
}
function Circle(props) {
    return _jsx(CircleMarker, { size: props.size, style: props.style }, void 0);
}
function Diamond(props) {
    return _jsx(DiamondMarker, { size: props.size, style: props.style }, void 0);
}
function Square(props) {
    return _jsx(SquareMarker, { size: props.size, style: props.style }, void 0);
}
export default function Shape(props) {
    const Figure = shapes[props.shape];
    const { x, y } = usePosition({ x: props.x, y: props.y });
    return (_jsx("g", Object.assign({ transform: `translate(${x}, ${y})` }, { children: _jsx(Figure, { size: props.size, style: props.style }, void 0) }), void 0));
}
//# sourceMappingURL=Shape.js.map